<template>
  <el-row>
    <el-col :span="24">
      <el-dialog title="添加考核" :visible.sync="dialogVisible" :close-on-click-modal="false" width="750px" :show-close="false" class="lx-dialog">
        <!--<div slot="title" style="display: flex; justify-content: space-between;">-->
          <!--<span>添加考核</span>-->
          <!--<el-button class="el-dialog__headerbtn">x</el-button>-->
        <!--</div>-->
        <el-form label-width="120px" ref="checkForm" :model="checkForm" :rules="checkFormRules">
          <el-form-item label="考核名称" prop="name">
            <el-input v-model="checkForm.name" class="form-inner"></el-input>
          </el-form-item>
          <el-form-item label="选择学年">
            <el-select v-model="checkForm.year" class="l-d-no-border">
              <el-option v-for="item in checkForm.years" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择学期" prop="term">
            <el-select v-model="checkForm.term" class="l-d-no-border" placeholder="请选择学期" @change="computeCheckName">
              <el-option v-for="item in checkForm.terms" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="考核对象" prop="object">
            <el-checkbox-group v-model="checkForm.object" class="l-d-no-border" size="medium">
              <el-checkbox-button v-for="(obj, index) in checkForm.objects" :label="obj.value" :key="index">{{obj.name}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="考核时间" required>
            <el-col :span="10">
              <el-form-item prop="date1">
                <el-date-picker type="datetime" placeholder="开始时间" v-model="checkForm.date1" @change="checkStart" :picker-options="startPickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="10">
              <el-form-item prop="date2">
                <el-date-picker
                  v-model="checkForm.date2"
                  type="datetime"
                  @focus="checkEnd"
                  :picker-options="endPickerOptions"
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="时长限制" prop="time">
            <el-input v-model="checkForm.time" class="form-inner" style="width: 70px;"></el-input>分钟
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel()">取 消</el-button>
            <el-button type="primary" @click="sureAdd('checkForm')" :disabled="sureStatus">确 定</el-button>
              <!--<el-button v-else type="primary" @click="sureEditModel('handleModelForm')">确 定</el-button>-->
          </span>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import _ from 'lodash'
import __ from '@/util/common-utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
export default {
  props: ['dialogVisible', 'checkName'],
  data () {
    var validateName = (rule, value, callback) => {
      var str = value.replace(/\s*/g, '')
      if (str === '') {
        callback(new Error('请输入考核名称'))
      } else {
        callback()
      }
    }
    var checkTime = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('时长不能为空！'))
      } else {
        let boolean = new RegExp(`^[1-9]\\d*$`).test(value)
        if (!boolean) {
          return callback(new Error('时长只能是正整数！'))
        } else {
          callback()
        }
      }
    }
    return {
      checkFormRules: {
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        term: [
          { required: true, message: '请选择学期', trigger: 'change' }
        ],
        object: [
          { type: 'array', required: true, message: '请至少选择一个班级', trigger: 'change' }
        ],
        date1: [
          { type: 'date', required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        date2: [
          { type: 'date', required: true, message: '请选择结束时间', trigger: 'change' }
        ],
        time: [
          { validator: checkTime, trigger: 'blur' }
        ]
      },
      checkForm: {
        name: '',
        year: '',
        years: [],
        term: '1',
        terms: [
          { name: '上学期', value: '1' },
          { name: '下学期', value: '2' }
        ],
        object: [],
        objects: [],
        date1: '',
        date2: '',
        time: 60
      },
      sureStatus: false,
      startPickerOptions: this.startDate(),
      endPickerOptions: {}
    }
  },
  watch: {
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.$xhrGet(`/checks/classes`).then(rs => {
        if (rs.code === 200) {
          this.checkForm.objects = rs.data
          this.sureStatus = false
        }
      })
      let schoolYear = __.defaultSchoolYear()
      this.checkForm.year = schoolYear
      this.checkForm.years = [{ name: __.getSchoolYearDesc(schoolYear), value: schoolYear }]
      this.computeCheckName()
    },
    computeCheckName () {
      let year = _.get(_.find(this.checkForm.years, { value: this.checkForm.year }), 'name') || ''
      let term = _.get(_.find(this.checkForm.terms, { value: this.checkForm.term }), 'name') || ''
      this.checkForm.name = year + term + this.checkName.name + '技能考核'
    },
    startDate () {
      return {
        disabledDate (date) {
          return date.getTime() < Date.now() - 8.64e7
        }
      }
    },
    checkStart (val) {
      if (val >= this.checkForm.date2) {
        this.checkForm.date2 = ''
      }
    },
    checkEnd () {
      let startDate = this.checkForm.date1
      if (!startDate) {
        this.$message.warning('请先选择开始时间')
        this.endPickerOptions = Object.assign({}, this.endPickerOptions, {
          disabledDate: (date) => {
            return true
          }
        })
      } else {
        this.endPickerOptions = Object.assign({}, this.endPickerOptions, {
          disabledDate: (date) => {
            return date.getTime() < new Date(startDate).getTime() - 23 * 60 * 60 * 1000
          }
        })
      }
    },
    sureAdd (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.sureStatus = true
          let startTime = moment(this.checkForm.date1.getTime()).format(('YYYY-MM-DD HH:mm:ss'))
          let endTime = moment(this.checkForm.date2.getTime()).format(('YYYY-MM-DD HH:mm:ss'))
          let date1 = this.checkForm.date1
          let date2 = this.checkForm.date2
          let scoreForm = { }
          switch (this.checkName.value) {
            case 1: scoreForm = {
              'check': {
                'equipment': {
                  'score': 5,
                  'type': 105
                },
                'tool': {
                  'score': 10
                },
                'scaleWatch': {
                  'score': 5
                },
                'sparePart': {
                  'score': 5
                }
              },
              'content': {
                'question1': {
                  'score': 4,
                  'testValue': null,
                  'answer': 1
                },
                'question2': {
                  'score': 2,
                  'testValue': null,
                  'answer': 1
                },
                'question3': {
                  'score': 10,
                  'testValue': 539,
                  'testValue2': -1,
                  'answer': 1
                },
                'question4': {
                  'score': 4,
                  'testValue': 2.3,
                  'answer': 1
                },
                'question5': {
                  'score': 4,
                  'testValue': -1,
                  'answer': 1
                },
                'question6': {
                  'score': 5,
                  'testValue': null,
                  'answer': 1
                },
                'question7': {
                  'score': 5,
                  'testValue': 0,
                  'answer': 1
                },
                'question8': {
                  'score': 4,
                  'testValue': -1,
                  'answer': 1
                },
                'question9': {
                  'score': 10,
                  'testValue': 485,
                  'testValue2': -1,
                  'answer': 1
                },
                'question10': {
                  'score': 10,
                  'testValue': 493,
                  'testValue2': -1,
                  'answer': 1
                },
                'question11': {
                  'score': 5,
                  'testValue': 10.26,
                  'answer': 1
                }
              }
            }; break
            case 2: scoreForm = {
              'content': {
                'question1': {
                  'score': 10,
                  'testValue': 78.63
                },
                'question2': {
                  'score': 10,
                  'testValue': 78.58
                },
                'question3': {
                  'score': 10,
                  'testValue': 78.62
                },
                'question4': {
                  'score': 10,
                  'testValue': 78.58
                },
                'question5': {
                  'score': 10,
                  'testValue': 78.55
                },
                'question6': {
                  'score': 10,
                  'testValue': 78.54
                },
                'question7': {
                  'score': 10,
                  'testValue': 78.00
                },
                'question8': {
                  'score': 10,
                  'testValue': 0.04
                },
                'question9': {
                  'score': 20,
                  'answer': 2
                }
              }}; break
            case 3: scoreForm = {
              'content': {
                'question1': {
                  'score': 10,
                  'testValue': 49.880
                },
                'question2': {
                  'score': 10,
                  'testValue': 49.880
                },
                'question3': {
                  'score': 10,
                  'testValue': 49.960
                },
                'question4': {
                  'score': 10,
                  'testValue': 49.870
                },
                'question5': {
                  'score': 10,
                  'testValue': 49.870
                },
                'question6': {
                  'score': 10,
                  'testValue': 0.005
                },
                'question7': {
                  'score': 10,
                  'testValue': 0.14
                },
                'question8': {
                  'score': 15,
                  'answer': 2
                },
                'question9': {
                  'score': 15,
                  'answer': 2
                }
              }
            }; break
            case 4: scoreForm = {
              'content': {
                'question1': {
                  'score': 6
                },
                'question2': {
                  'score': 6
                },
                'question3': {
                  'score': 6
                },
                'question4': {
                  'score': 6
                },
                'question5': {
                  'score': 6
                },
                'question6': {
                  'score': 6
                },
                'question7': {
                  'score': 6
                },
                'question8': {
                  'score': 6
                },
                'question9': {
                  'score': 5,
                  'testValue': 0.8
                },
                'question10': {
                  'score': 5,
                  'testValue': 0.7
                },
                'question11': {
                  'score': 5,
                  'testValue': 0.7
                },
                'question12': {
                  'score': 5,
                  'testValue': 0.8
                },
                'question13': {
                  'score': 5,
                  'testValue': 0.7
                },
                'question14': {
                  'score': 5,
                  'testValue': 0.8
                },
                'question15': {
                  'score': 5,
                  'testValue': 0.75
                },
                'question16': {
                  'score': 5,
                  'answer': 1
                }
              }
            }
          }
          let queryForm = {
            name: this.checkForm.name,
            schoolYear: this.checkForm.year,
            schoolTerm: this.checkForm.term,
            trainProjectId: this.checkName.value,
            startTime: startTime,
            endTime: endTime,
            duration: this.checkForm.time,
            classIds: this.checkForm.object,
            settings: JSON.stringify(scoreForm)
          }
          this.$xhrPost(`/checks`, queryForm).then(rs => {
            if (rs.code === 400) {
              if (date1 < Date.now()) {
                this.$message.error('开始时间需要大于此刻')
              }
              if (date2 <= date1) {
                this.$message.error('结束时间需要大于开始时间')
              }
              this.sureStatus = false
            }
            if (rs.code === 403) {
              this.$message.error('考核时间需要长于考试时长')
              this.sureStatus = false
            }
            if (rs.code === 200) {
              this.$refs[form].resetFields()
              this.$emit('check-add', true)
              this.initData()
            }
          })
        } else {
          return false
        }
      })
    },
    closeDialog () {
      this.$emit('dialog-close', true)
      this.$refs['checkForm'].resetFields()
    },
    cancel () {
      this.$emit('dialog-close', true)
      this.$refs['checkForm'].resetFields()
    }
  }
}
</script>

<style scoped>
/deep/ .el-input__inner { border: 0; }
</style>



// WEBPACK FOOTER //
// src/components/check/CheckDialog.vue